import { Card, CardContent } from '@mui/material';

import { useProductImage } from '../../../services/productImage';

export interface ProductImageDataProps {
  serialNumber: any;
}

export const ProductImage = ({ serialNumber }: ProductImageDataProps) => {
  const { productImage, isLoading } = useProductImage(serialNumber);

  if (isLoading) {
    return null;
  }

  if (productImage?.main) {
    return (
      <div style={{ width: '50%' }}>
        <Card variant="elevation" sx={{ borderRadius: 0 }}>
          <CardContent>
            <img
              style={{ width: '100%' }}
              src={productImage.main}
              alt="Product"
            />
          </CardContent>
        </Card>
      </div>
    );
  }
  return null;
};
